module.exports = __webpack_public_path__ + "static/media/email.fc5bb195.png";